export const BUTTON_STYLE = {
    DEFAULT:{color:'black', borderColor:'black'},
    CLICKED:{color:'yellow', borderColor:'yellow'},
    SAVED:{color:'green', borderColor:'green'},
    ERROR:{color:'red', borderColor:'red'},
  }
  